// ==============================|| CUSTOM FUNCTION - COLOR SHADOWS ||============================== //

import type { Theme } from '@mui/material/styles';

type ShadowKey =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success'
  | 'primaryButton'
  | 'secondaryButton'
  | 'errorButton'
  | 'warningButton'
  | 'infoButton'
  | 'successButton';

type ThemeVarsWithShadows = NonNullable<Theme['vars']> & {
  customShadows: Record<ShadowKey, string>;
};

export default function getShadow(theme: Theme, shadow: ShadowKey | string) {
  const vars = theme.vars as ThemeVarsWithShadows | undefined;

  if (!vars) return 'none';

  switch (shadow) {
    case 'secondary':
      return vars.customShadows.secondary;
    case 'error':
      return vars.customShadows.error;
    case 'warning':
      return vars.customShadows.warning;
    case 'info':
      return vars.customShadows.info;
    case 'success':
      return vars.customShadows.success;
    case 'primaryButton':
      return vars.customShadows.primaryButton;
    case 'secondaryButton':
      return vars.customShadows.secondaryButton;
    case 'errorButton':
      return vars.customShadows.errorButton;
    case 'warningButton':
      return vars.customShadows.warningButton;
    case 'infoButton':
      return vars.customShadows.infoButton;
    case 'successButton':
      return vars.customShadows.successButton;
    default:
      return vars.customShadows.primary;
  }
}
